import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  header: {
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: '2px solid #2563EB',
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  clinicInfo: {
    flex: 1,
  },
  clinicName: {
    fontSize: 18,
    fontWeight: 700,
    color: '#1E40AF',
    marginBottom: 4,
  },
  clinicDetails: {
    fontSize: 9,
    color: '#6B7280',
    lineHeight: 1.4,
  },
  documentTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1F2937',
    textAlign: 'center',
    marginTop: 8,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  documentSubtitle: {
    fontSize: 10,
    color: '#6B7280',
    textAlign: 'center',
    marginTop: 4,
  },
});

export default function PDFHeader({ 
  organization, 
  clinic, 
  documentTitle, 
  documentSubtitle 
}) {
  // Prefer organization (practice) for name; use clinic for branch address/contact when present
  const name = organization?.name || clinic?.name || 'Dental Clinic';
  const address = clinic?.address || organization?.address || {};
  const phone = (Array.isArray(clinic?.contactNumbers) && clinic.contactNumbers[0])
    || clinic?.phone
    || organization?.contactInfo?.phone
    || null;
  const email = clinic?.email || organization?.contactInfo?.email || null;

  const addressLine = [
    address.street,
    address.city,
    address.state,
    address.pincode,
    address.country
  ].filter(Boolean).join(', ');

  return (
    <View style={styles.header}>
      <View style={styles.headerRow}>
        <View style={styles.clinicInfo}>
          <Text style={styles.clinicName}>{name}</Text>
          {addressLine && (
            <Text style={styles.clinicDetails}>{addressLine}</Text>
          )}
          {phone && (
            <Text style={styles.clinicDetails}>Phone: {phone}</Text>
          )}
          {email && (
            <Text style={styles.clinicDetails}>Email: {email}</Text>
          )}
        </View>
      </View>
      {documentTitle && (
        <Text style={styles.documentTitle}>{documentTitle}</Text>
      )}
      {documentSubtitle && (
        <Text style={styles.documentSubtitle}>{documentSubtitle}</Text>
      )}
    </View>
  );
}
